// extracted by mini-css-extract-plugin
module.exports = {"panel":"ContentLibrarySidebar_panel__yF9jw","primary":"ContentLibrarySidebar_primary__cYdZt","grid":"ContentLibrarySidebar_grid__OFXPd"};